import { FaHandsHelping, FaStore, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AdminSidebarShell from "../components/AdminSidebarShell";

const AdminPlaceholderPage = ({ activeItem = "dashboard", title, subtitle }) => {
  const navigate = useNavigate();
  const isAgenticPage = activeItem === "agentic";

  return (
    <AdminSidebarShell activeItem={activeItem}>
      <div style={container}>
        <div style={card}>
          <h1 style={heading}>{title}</h1>
          <p style={text}>{subtitle}</p>
          {isAgenticPage ? (
            <div style={serviceGrid}>
              <button
                type="button"
                style={serviceCard}
                onClick={() => navigate("/patientmap")}
              >
                <div style={serviceIcon}>
                  <FaHandsHelping />
                </div>
                <div style={serviceBody}>
                  <h2 style={serviceTitle}>Uber Care</h2>
                  <p style={serviceText}>Open the patient map and view care support locations.</p>
                </div>
                <FaArrowRight style={serviceArrow} />
              </button>

              <button
                type="button"
                style={serviceCard}
                onClick={() => {}}
              >
                <div style={serviceIcon}>
                  <FaStore />
                </div>
                <div style={serviceBody}>
                  <h2 style={serviceTitle}>Agentics Market Place</h2>
                  <p style={serviceText}>Marketplace services will be added here.</p>
                </div>
                <FaArrowRight style={serviceArrow} />
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </AdminSidebarShell>
  );
};

export default AdminPlaceholderPage;

const container = {
  maxWidth: "1080px",
  margin: "0 auto"
};

const card = {
  background: "#ffffff",
  border: "1px solid #e2e8f0",
  borderRadius: "16px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
  padding: "24px"
};

const heading = {
  margin: "0 0 8px 0",
  color: "#1e293b",
  fontSize: "28px"
};

const text = {
  margin: 0,
  color: "#64748b",
  fontSize: "15px"
};

const serviceGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "18px",
  marginTop: "24px"
};

const serviceCard = {
  width: "100%",
  border: "1px solid #dce6ef",
  borderRadius: "16px",
  background: "#f8fbfe",
  padding: "20px",
  display: "flex",
  alignItems: "flex-start",
  gap: "16px",
  textAlign: "left",
  cursor: "pointer"
};

const serviceIcon = {
  width: "50px",
  height: "50px",
  borderRadius: "14px",
  background: "#e8f3fb",
  color: "#0E5580",
  display: "grid",
  placeItems: "center",
  fontSize: "22px",
  flexShrink: 0
};

const serviceBody = {
  flex: 1
};

const serviceTitle = {
  margin: 0,
  color: "#1e293b",
  fontSize: "20px"
};

const serviceText = {
  margin: "8px 0 0",
  color: "#64748b",
  fontSize: "14px"
};

const serviceArrow = {
  color: "#94a3b8",
  fontSize: "18px",
  marginTop: "6px",
  flexShrink: 0
};
